import { getIdToken } from "firebase/auth";
import { auth } from "../services/firebase.js";

const API_BASE =
  process.env.REACT_APP_API_BASE || "https://codaco-backend.onrender.com";

const RENDER_PDF_BASE = `${API_BASE}/api/download`;

export async function downloadDocument(filename, onProgress) {
  const user = auth.currentUser;
  if (!user) throw new Error("User is not logged in.");

  const token = await getIdToken(user, true);
  const url = `${RENDER_PDF_BASE}/${encodeURIComponent(filename)}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Download failed.");
  }

  const contentType = response.headers.get("Content-Type") || "";
  if (!contentType.toLowerCase().includes("application/pdf")) {
    const text = await response.text();
    throw new Error("Server nevrátil PDF soubor.\n" + text.slice(0, 200));
  }

  const total = parseInt(response.headers.get("Content-Length") || "0", 10);
  let loaded = 0;

  if (!response.body) {
    const blob = await response.blob();
    triggerDownload(blob, filename);
    if (onProgress) onProgress(1, 1);
    return;
  }

  const reader = response.body.getReader();
  const chunks = [];

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    chunks.push(value);
    loaded += value.length;

    if (onProgress && total) {
      onProgress(loaded, total);
    }
  }

  const blob = new Blob(chunks, { type: "application/pdf" });
  triggerDownload(blob, filename);

  if (onProgress) {
    onProgress(total || 1, total || 1);
  }
}

function triggerDownload(blob, filename) {
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;

  document.body.appendChild(a);
  a.click();
  a.remove();

  window.URL.revokeObjectURL(url);
}
